module.exports = __webpack_public_path__ + "img/product-shansuan-zsyy-07.c609f55d.png";